/** Keep bell + Messages + Teams nav badges in sync after notification or match-chat changes. */

export function syncPlayerNotificationsAfterMatchChat(queryClient) {
  if (!queryClient) return;
  queryClient.invalidateQueries(['playerNotificationCount']);
  queryClient.invalidateQueries(['playerNotificationCount', 'messages']);
  queryClient.invalidateQueries(['playerNotifications']);
  queryClient.invalidateQueries(['playerNotificationsUnreadSummary']);
  queryClient.invalidateQueries(['playerTeamsCardActivity']);
  queryClient.invalidateQueries(['playerConversations']);
}

export function clearPlayerNotificationBadgeCache(queryClient) {
  if (!queryClient) return;
  queryClient.setQueryData(['playerNotificationCount'], {
    success: true,
    data: { unreadCount: 0 },
    unreadCount: 0,
  });
  queryClient.setQueryData(['playerNotificationCount', 'messages'], {
    success: true,
    data: { unreadCount: 0 },
    unreadCount: 0,
  });
  queryClient.setQueryData(['playerNotificationsUnreadSummary'], {
    success: true,
    data: { byTeamId: {}, byLeagueMatchId: {}, totalTeamUnread: 0 },
  });
}

export function invalidatePlayerNotificationQueries(queryClient) {
  syncPlayerNotificationsAfterMatchChat(queryClient);
  queryClient.invalidateQueries(['playerTeamsLeagueEngagement']);
}
